import request from '../request'
import { SubscibeURL } from 'constants/url'

const formatSubscribeURL = (webinarId: number | string) => `${SubscibeURL.WEBINAR}/${webinarId}`

const subscribe = (webinarId: number | string) =>
  request({ url: formatSubscribeURL(webinarId), method: 'post' })

const unsubscribe = (webinarId: number | string) =>
  request({ url: formatSubscribeURL(webinarId), method: 'delete' })

export { subscribe, unsubscribe }
